import classNames from 'classnames'

interface Props {
  children: React.ReactNode
  className?: string
  variant?: 'neutral' | 'info'
}

export const NoticeCard: React.FC<Props> = ({
  children,
  className,
  variant = 'neutral',
}) => {
  return (
    <div
      className={classNames(
        'rounded-lg p-4 border-2',
        {
          'bg-core-gray-100 border-core-gray-300': variant === 'neutral',
          'bg-core-info-100 border-core-info-300': variant === 'info',
        },
        className
      )}
    >
      {children}
    </div>
  )
}
